import { QueryClient } from '@tanstack/react-query'

/**
 * TanStack Query のグローバル設定
 *
 * デフォルト設定は一般的なクエリ（設定、マスタ等）向け。
 * ポーリングが必要な処方箋リスト等は個別に refetchInterval を設定する。
 *
 * @see https://tanstack.com/query/latest/docs/reference/QueryClient
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // データが古くなるまでの時間（5分）
      staleTime: 1000 * 60 * 5,

      // キャッシュに保持する時間（10分）
      gcTime: 1000 * 60 * 10,

      // エラー時のリトライ回数
      retry: 1,

      // ウィンドウフォーカス時の再取得を無効化
      // （処方箋管理システムでは意図しない再取得を防ぐ）
      refetchOnWindowFocus: false,

      // マウント時の再取得を無効化
      refetchOnMount: false,

      // ネットワーク再接続時の再取得
      refetchOnReconnect: true,
    },
    mutations: {
      // ミューテーションのリトライは行わない
      retry: false,
    },
  },
})
